import ContentUploader from './ContentUploader';
import makePopup from '../common/makePopup';
import { CLIENT_NAME_CONTENT_UPLOADER } from '../../constants';

export default makePopup(CLIENT_NAME_CONTENT_UPLOADER)(ContentUploader);
